import React from "react";
import { useNavigate } from "react-router-dom";

import {
  Wrap,
  Inner,
  Title,
  Script,
  PortraitWrap,
  PortraitFrame,
  PortraitImg,
  GoldLine,
  Text,
  Actions,
  PrimaryBtn,
} from "./AboutStorySectionStyles";

export default function AboutStorySection({
  title = "Despre Ahava Cakes",
  script = "Pasiune moștenită. Gusturi care spun o poveste.",
  imageSrc = null,
  imageAlt = "Ahava Cakes story",
  paragraphs = [
    "Ahava Cakes este un laborator de cofetărie artizanală din inima Aradului, născut din iubirea dintre o mamă și fiica ei – amândouă unite de aceeași pasiune: creația deserturilor care bucură sufletul.",
    "Mama, cu experiență de o viață în arta cofetariei și fiica, inspirată de mirosul copilăriei și de emoția momentelor dulci, au decis să transforme o tradiție de familie într-un atelier al rafinamentului și al bucuriei.",
  ],
  primaryCta = { label: "Vezi produse", onClick: null },
}) {
  return (
    <Wrap>
      <Inner>
        <Title>{title}</Title>
        <Script>{script}</Script>

        {imageSrc ? (
          <PortraitWrap aria-hidden="false">
            <PortraitFrame>
              <PortraitImg src={imageSrc} alt={imageAlt} loading="lazy" />
            </PortraitFrame>
          </PortraitWrap>
        ) : null}

        <GoldLine />

        {paragraphs.map((p, i) => (
          <Text key={i}>{p}</Text>
        ))}

        <Actions>
          <PrimaryBtn type="button" onClick={primaryCta?.onClick || undefined}>
            {primaryCta?.label}
          </PrimaryBtn>
        </Actions>
      </Inner>
    </Wrap>
  );
}
